import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=1abfe41b"
import script from "../../controllers/book_library/book-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/book_library/book-list.js?vue&type=script&lang=js&external"
import style0 from "./BookList.vue?vue&type=style&index=0&id=1abfe41b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports